<template>
  <Modal v-model="visible" title="本期扣款" width="900" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <Form :model="formData" ref="infoFormRef" class="page-form" :label-width="90" v-if="visible" label-position="right">
      <FormItem label="保单号：" class="ivu-form-item">
        <span>{{ formData.policyNo }}</span>
      </FormItem>

      <FormItem label="产品名称：" class="ivu-form-item">
        <span>{{ formData.productName }}</span>
      </FormItem>

      <FormItem label="险种名称：" class="ivu-form-item">
        <span>{{ formData.insuranceName }}</span>
      </FormItem>

      <FormItem label="保单年度：" class="ivu-form-item">
        <span>{{ formData.commissionIndex }}</span>
      </FormItem>

      <FormItem label="交费期次：" class="ivu-form-item">
        <span>{{ formData.commissionPeriods }}</span>
      </FormItem>

      <FormItem label="原保费：" class="ivu-form-item">
        <span>{{ oldFee }}</span>
      </FormItem>

      <FormItem label="费用归属：" class="ivu-form-item">
        <span>{{ formData.owerName }}</span>
      </FormItem>

      <FormItem label="费用类型：" class="ivu-form-item">
        <span v-if="formData.commissionType == 1 || formData.commissionType == 3">基础费用</span>
        <span v-else-if="formData.commissionType == 5">后置费用</span>
      </FormItem>

      <FormItem label="结算状态：" class="ivu-form-item">
        <span>{{ formData.settlementStatus == '1' ? '已结算' : '未结算' }}</span>
      </FormItem>

      <FormItem label="结算费用：" class="ivu-form-item" v-if="formData.settlementStatus == '1'">
        <span>{{ commissionPrice }}</span
        >元
      </FormItem>

      <div class="less">
        <FormItem label="退费金额：" prop="fee" class="form-item" style="width: 40%">
          <Input type="number" @on-change="countCommissionPrice" v-model="formData.fee" style="width: 80%" placeholder="请输入" />
          <span class="unit">元</span>
        </FormItem>

        <FormItem
          label="本期扣除费用："
          prop="commissionPrice"
          :rules="$units.formRule.required('请输入本期扣除费用', 'change', 'number')"
          :label-width="120"
          class="form-item"
          style="width: 40%"
        >
          <InputNumber v-model="formData.commissionPrice" :min="0" placeholder="请输入" style="width: 80%"></InputNumber>
          <span class="unit">元</span>
        </FormItem>
      </div>

      <div class="less">
        <FormItem label="扣款原因：" prop="deductType" :rules="$units.formRule.required('请选择扣款原因', 'change')" style="width: 100%">
          <Select v-model="formData.deductType" placeholder="请选择" filterable clearable transfer>
            <Option value="1">退保</Option>
            <Option value="2">部分退保</Option>
            <Option value="3">退现价</Option>
            <Option value="4">其他</Option>
          </Select>
        </FormItem>
      </div>

      <div class="full" v-if="formData.deductType == 4">
        <FormItem label="" prop="deductMsg" :rules="$units.formRule.required('请填写原因')" style="width: 100%">
          <Input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" v-model="formData.deductMsg" placeholder="请输入" />
        </FormItem>
      </div>
    </Form>

    <div class="ivu-modal-footer">
      <Button @click="visible = false">取消</Button>
      <Button type="primary" @click="ok" :loading="loading">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
export default {
  mixins: [pageTool, common],
  props: ['policyType'],
  data() {
    return {
      commissionPrice: 0,
      netCommission: 0,
      oldFee: '',
      netIncome: null,
      formData: {
        commissionPrice: null,
        deductType: '',
        deductMsg: ''
      },
      visible: false,
      loading: false,
      edit: false
    };
  },
  methods: {
    async open(item, edit) {
      this.edit = edit;
      this.netIncome = item.netIncome;
      await this.getDetail(item.id, item);
      this.getOldFee(item);
      this.visible = true;
    },

    getDetail(id, item) {
      return this.$http({
        url: '/buz/commissionLog/read/detail',
        type: 'GET',
        data: {
          id
        }
      }).then(res => {
        this.formData.policyNo = res.data.policyNo;
        this.formData.commissionIndex = res.data.commissionIndex;
        this.formData.commissionPeriods = res.data.commissionPeriods;
        this.formData.settlementStatus = res.data.settlementStatus;
        this.formData.productName = item.productName;
        this.formData.insuranceName = item.insuranceName;
        this.formData.commissionType = res.data.commissionType;
        this.formData.owerName = item.owerName;
        this.formData.fee = Math.abs(item.fee);
        this.oldFee = res.data.fee;
        this.formData.commissionPrice = Math.abs(item.netIncome);
        this.commissionPrice = item.netIncome;
        this.netCommission = item.netCommission;
        this.formData.deductType = item.deductType;
        this.formData.deductMsg = item.deductMsg;
        this.formData.id = item.id;
      });
    },

    getOldFee(item) {
      if (!item.deductLogId) return;
      this.$http({
        url: '/buz/commissionLog/read/detail',
        type: 'GET',
        data: {
          id: item.deductLogId
        }
      }).then(res => {
        this.$set(this, 'oldFee', res.data.fee);
      });
    },

    countCommissionPrice(e) {
      if (this.netCommission) {
        let num = Number(e.target.value) * (Number(this.netCommission) / 100);
        this.$set(this.formData, 'commissionPrice', Number(Number(num).toFixed(2)));
      } else {
        this.$set(this.formData, 'commissionPrice', null);
      }
    },

    ok() {
      this.$refs.infoFormRef.validate().then(isok => {
        if (!isok) {
          return;
        }
        this.loading = true;
        let data = JSON.parse(JSON.stringify(this.formData));
        let url = '';
        let params = {
          commissionPrice: '-' + data.commissionPrice,
          deductType: data.deductType,
          deductMsg: data.deductType == 4 ? data.deductMsg : '',
          fee: '-' + data.fee
        };
        if (this.edit) {
          params.id = data.id;
          url = '/buz/commissionLog/changeDeduct';
        } else {
          params.commissionLogId = data.id;
          params.netIncome = this.netIncome;
          url = '/buz/commissionLog/deductCommission';
        }
        this.$http({
          url,
          type: 'POST',
          data: params
        }).then(res => {
          this.visible = false;
          this.loading = false;
          this.$emit('success');
        }).catch(()=>{
          this.loading = false;
        })
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-item {
  .unit {
    margin-left: 10px;
    font-size: 14px;
  }
}
</style>
